var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tailwind-grid-demo"}},[_c('grid-basic-grid'),_c('grid-responsive-grids'),_c('grid-mixed-column-sizes'),_c('grid-wrapping-columns'),_c('grid-column-spacing'),_c('grid-auto-column-width'),_c('grid-simple-offset')],1)}
var staticRenderFns = []

export { render, staticRenderFns }